import { render, staticRenderFns } from "./PharmacistItem.vue?vue&type=template&id=01da48d3&scoped=true&"
import script from "./PharmacistItem.vue?vue&type=script&lang=ts&"
export * from "./PharmacistItem.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistItem.vue?vue&type=style&index=0&id=01da48d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da48d3",
  null
  
)

export default component.exports